import { render, staticRenderFns } from "./ChatAiIcon.vue?vue&type=template&id=593ed515&scoped=true"
import script from "./ChatAiIcon.vue?vue&type=script&lang=js"
export * from "./ChatAiIcon.vue?vue&type=script&lang=js"
import style0 from "./ChatAiIcon.vue?vue&type=style&index=0&id=593ed515&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ed515",
  null
  
)

export default component.exports